module.exports = __webpack_public_path__ + "img/2024-07-01c_3.f66e29c2.jpg";